<template>
  <el-table
    v-loading="loading"
    :data="rows"
    border
    stripe
    :height="height"
    show-summary
    :summary-method="summaryMethod"
  >
    <el-table-column
      v-for="column in dimensionColumns"
      :key="column.prop"
      :prop="column.prop"
      :label="column.label"
      :width="column.width"
      :min-width="column.minWidth || 120"
      :fixed="column.fixed"
      show-overflow-tooltip
    />
    <el-table-column v-for="month in 12" :key="month" :label="`${month}月`" width="120" align="right">
      <template slot-scope="scope">{{ amount((scope.row.monthAmounts || [])[month - 1]) }}</template>
    </el-table-column>
    <el-table-column label="全年合计" width="140" align="right" fixed="right">
      <template slot-scope="scope">{{ amount(scope.row.totalAmount) }}</template>
    </el-table-column>
  </el-table>
</template>

<script>
import { amount } from './financeShared'

export default {
  name: 'FinanceMonthlyTable',
  props: {
    rows: { type: Array, default: () => [] },
    dimensionColumns: { type: Array, default: () => [] },
    loading: Boolean,
    height: { type: [String, Number], default: 560 }
  },
  methods: {
    amount,
    summaryMethod ({ columns, data }) {
      const dimensionCount = this.dimensionColumns.length
      return columns.map((column, index) => {
        if (index === 0) return '合计'
        if (index < dimensionCount) return ''
        const monthIndex = index - dimensionCount
        const total = data.reduce((sum, row) => {
          if (monthIndex < 12) return sum + Number((row.monthAmounts || [])[monthIndex] || 0)
          return sum + Number(row.totalAmount || 0)
        }, 0)
        return amount(total)
      })
    }
  }
}
</script>
